import { SubscriptionEntitlement } from '~/api/graphql';
import { useEntitlements } from '~/components/entitlements';

export const useTriggersEntitlement = () => {
  const { hasEntitlement } = useEntitlements();
  return hasEntitlement(SubscriptionEntitlement.WorkflowTriggers);
};
